import axios from "axios";
// import store from '@/store/index.js' //状态管理
import router from "@/router.js"; // 路由
import VueCookies from "vue-cookies";
import Message from "ant-design-vue/lib/message"; // 加载 JS
import "ant-design-vue/lib/message/style/css"; // 加载 CSS

axios.defaults.timeout = 60000; // 超时终止请求
axios.defaults.baseURL = "https://call-api.qkids.cn/api/";
// axios.defaults.baseURL = 'http://localhost:9010/api/'
// 配置请求地址 http://192.168.1.5:8080/oauth2service/
axios.defaults.headers["Content-Type"] = "application/json"; // 添加headers
// axios.defaults.transformRequest = [function (data) {
//   // 对 data 进行任意转换处理
//   // console.log(data)
//   return Qs.stringify(data)
// }]
axios.defaults.headers["Authorization"] =
  "Bearer Y2xpZW50XzI6JDJhJDEwJHRtUDc4bUJqWEU1cmwxd3NSbFVwRE9tRnJQM1k2OFEvUC9kSUk4L3hxeEJlMlBkM3FFSFdX";
// 授权服务器
// //http request 请求拦截器
axios.interceptors.request.use(
  config => {
    let accessToken = "";
    // 取值refresh_token
    if (localStorage.token != null && localStorage.token !== "") {
      accessToken = localStorage.token;
    }
    // console.log(refresh_token);
    // config.data = JSON.stringify(config.data);
    // config.headers = {
    //   'Content-Type':'application/x-www-form-urlencoded'
    //   // 'Content-Type':'application/json;charset=UTF-8'
    // }
    if (accessToken != null && accessToken !== "") {
      // 如果有token,将默认传入每次请求的数据中
      // console.log(config)
      config.headers.Authorization = "Bearer " + accessToken;
    } else {
      // 没有token 跳转到首页
      console.log("没有 Toekn，返回登录");
      router.push({ path: "/" }); // 跳转到登陆
    }
    console.log(config);
    return config;
  },
  error => {
    // 错误跳转到首页
    router.push({ path: "/" }); // 跳转到登陆
    return Promise.reject(error);
  }
);

// //http response 响应拦截器
axios.interceptors.response.use(
  response => {
    // console.log('拦截器：' + response)
    // if (response.data.status !== 200) {
    //   // router.push({
    //   //     path:"/",
    //   //     querry:{redirect:router.currentRoute.fullPath}//从哪个页面跳转
    //   //   })
    //   Message.error(response.data.msg)
    // }
    return response;
  },
  error => {
    // 删除cookie
    VueCookies.remove("userInfo"); // 防止服务器token过期时的无限请求失败
    router.push({
      path: "/",
      querry: { redirect: router.currentRoute.fullPath } // 从哪个页面跳转
    });
    Message.destroy(); // 销毁全局提示
    Message.error("无权访问，请重新登陆");
    return Promise.reject(error);
  }
);

/**
 * 获取登陆后的基本信息方法
 * @returns
 */
export function getUserinfo() {
  return { token: localStorage.token, refreshToken: localStorage.refreshToken };
}

export function setUserInfo(token, refreshToken) {
  localStorage.token = token;
  localStorage.refreshToken = refreshToken;
}
export function logoutWithCleanLocalStorage() {
  localStorage.removeItem("token");
  localStorage.removeItem("refreshToken");
  localStorage.removeItem("personID");
  localStorage.removeItem("isAdmin");
  localStorage.removeItem("refreshDate");
  router.push({ path: "/" });
}

/**
 * 封装get方法
 * @param url
 * @param params
 * @returns {Promise}
 */

export function get(url, params = {}) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params
      })
      .then(response => {
        resolve(response.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function post(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.post(url, data).then(
      response => {
        resolve(response.data);
      },
      err => {
        reject(err);
      }
    );
  });
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function patch(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.patch(url, data).then(
      response => {
        resolve(response.data);
      },
      err => {
        reject(err);
      }
    );
  });
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.put(url, data).then(
      response => {
        resolve(response.data);
      },
      err => {
        reject(err);
      }
    );
  });
}
